import { defineComponent } from 'vue';
import SupplierComponent from '@/components/SupplierComponent.vue';
export default defineComponent({
    name: 'SupplierDuplicateDialog',
    props: {
        propSelected: Array,
        propId: String
    },
    components: { SupplierComponent },
    data: function () {
        return {
            show: false,
            id: this.propId
        };
    },
    methods: {
        refresh() {
            this.$emit('refresh');
        },
        showHideDialog() {
            this.show = !this.show;
        },
        createNew() {
            this.show = true;
        }
    }
});
